import { combineEpics } from 'redux-observable';
import * as orderService from './order.service';
import * as userService from './user.service'

const epicsArray = [
    ...(Object as any).values(orderService),
    ...(Object as any).values(userService),
]

export const epics = combineEpics(...epicsArray);